var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_477_610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.0830078,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_477_610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20814 17.7753H10.0926V15.7753H12.0926V14.8908H10.0926V12.8908H9.20814V14.8908H7.20814V15.7753H9.20814V17.7753ZM14.2081 17.0253H18.5926V16.1408H14.2081V17.0253ZM14.2081 14.5253H18.5926V13.6408H14.2081V14.5253ZM15.0004 10.5715L16.4004 9.17151L17.8004 10.5715L18.4274 9.94451L17.0274 8.53301L18.4274 7.13301L17.8004 6.50601L16.4004 7.90601L15.0004 6.50601L14.3734 7.13301L15.7734 8.53301L14.3734 9.94451L15.0004 10.5715ZM7.45814 8.97526H11.8426V8.09076H7.45814V8.97526ZM6.51589 20.083C6.05556 20.083 5.67122 19.9288 5.36289 19.6205C5.05456 19.3122 4.90039 18.9278 4.90039 18.4675V5.69851C4.90039 5.23817 5.05456 4.85384 5.36289 4.54551C5.67122 4.23717 6.05556 4.08301 6.51589 4.08301H19.2849C19.7452 4.08301 20.1296 4.23717 20.4379 4.54551C20.7462 4.85384 20.9004 5.23817 20.9004 5.69851V18.4675C20.9004 18.9278 20.7462 19.3122 20.4379 19.6205C20.1296 19.9288 19.7452 20.083 19.2849 20.083H6.51589ZM6.51589 19.083H19.2849C19.4389 19.083 19.58 19.0189 19.7081 18.8908C19.8363 18.7626 19.9004 18.6215 19.9004 18.4675V5.69851C19.9004 5.54451 19.8363 5.40342 19.7081 5.27526C19.58 5.14709 19.4389 5.08301 19.2849 5.08301H6.51589C6.36189 5.08301 6.22081 5.14709 6.09264 5.27526C5.96447 5.40342 5.90039 5.54451 5.90039 5.69851V18.4675C5.90039 18.6215 5.96447 18.7626 6.09264 18.8908C6.22081 19.0189 6.36189 19.083 6.51589 19.083Z",
    fill: "#0E9384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculateIcon);
export default __webpack_public_path__ + "static/media/calculate-icon.756f26e4376843b0b5b228d36afaea14.svg";
export { ForwardRef as ReactComponent };